<template>
  <div v-loading="loading">
    <el-form :model="form" label-width="90px" ref="form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="下单时间">
            <el-date-picker class="w100" v-model="createTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品名称" prop="ProductName">
            <el-input v-model="form.ProductName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="订单号" prop="ChildOrderNo">
            <el-input v-model="form.ChildOrderNo" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="收货人" prop="ReceiverName">
            <el-input v-model="form.ReceiverName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="订单状态" prop="OrderStatus">
            <el-select v-model="form.OrderStatus" class="w100">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="10" label="待支付"></el-option>
              <el-option :value="20" label="备货中(待发货)"></el-option>
              <el-option :value="30" label="待收货(已发货)"></el-option>
              <el-option :value="40" label="已收货"></el-option>
              <el-option :value="50" label="已完成"></el-option>
              <el-option :value="60" label="已取消"></el-option>
              <el-option :value="70" label="已关闭"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结算时间">
            <el-date-picker class="w100" v-model="settlementTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item>
          <div class="flex">
            <el-button type="primary" @click="getData">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
            <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
          </div>
        </el-form-item>
      </el-row>
      <el-form-item label-width="0">
        <h2>结算合计：<span>¥{{ amount }}</span></h2>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border style="width: 100%;" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }">
      <el-table-column label="订单号" prop="childOrderNo" width="200"></el-table-column>
      <el-table-column label="下单时间" prop="createTime" width="200"></el-table-column>
      <el-table-column label="商品信息" width="200">
        <template slot-scope="scope">
          <p>商品名称：{{ scope.row.skuName }}</p>
          <p>购买规格：{{ scope.row.skuSpecification }}</p>
          <p>购买数量：{{ scope.row.skuNumber }}</p>
        </template>
      </el-table-column>
      <!-- <el-table-column label="收货信息" width="200">
        <template slot-scope="scope">
          <p>{{ scope.row.receiverName }}</p>
          <p>{{ scope.row.receiverPhone }}</p>
          <p>{{ scope.row.receiverProvinceName }} / {{ scope.row.receiverCityName }}</p>
          <p>{{ scope.row.receiverDistrictName }} / {{ scope.row.receiverStreetName }}</p>
          <p>{{ scope.row.receiverAddress }}</p>
        </template>
      </el-table-column> -->
      <el-table-column label="订单状态" prop="statusName" width="150"></el-table-column>
      <el-table-column label="发货数量" width="150">
        <template slot-scope="scope">
          {{ scope.row.sendSkuNumber }}/{{ scope.row.skuNumber }}
        </template>
      </el-table-column>
      <el-table-column label="物流签收" prop="checkSignSkuNumber" width="150"></el-table-column>
      <el-table-column label="退货" prop="refundSkuNumber" width="150"></el-table-column>
      <el-table-column label="单价" prop="skuBillPrice" width="150">
        <template slot-scope="scope">
          ¥{{ scope.row.skuBillPrice }}
        </template>
      </el-table-column>
      <el-table-column label="应收合计" prop="amount" width="150">
        <template slot-scope="scope">
          ¥{{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column label="退款金额" width="150">
        <template slot-scope="scope">
          ¥{{ scope.row.refundAmount }}
        </template>
      </el-table-column>
      <el-table-column label="结算金额" width="150">
        <template slot-scope="scope">
          <span style="color: red;">¥{{ scope.row.settlementAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结算时间" prop="settlementTime" width="200"></el-table-column>
    </el-table>
    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="form.PageIndex" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="form.PageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import {
  SysSettlementOrderList,
  SysSettlementOrderTotal,
  ExportSysSettlementOrderList
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      tableData: [],
      total: 0,
      loading: false,
      form: {
        SupIds: null,
        SettlementStatus: 1,
        CreateTimeStart: null,
        CreateTimeEnd: null,
        SettlementTimeStart: null,
        SettlementTimeEnd: null,
        ProductName: null,
        ChildOrderNo: null,
        ReceiverName: null,
        ReceiverPhone: null,
        OrderStatus: null,
        PageIndex: 1,
        PageSize: 10,
      },
      createTime: null,
      settlementTime: null,
      buttonList_toolBar: [],
      buttonList_table: [],
      amount: 0
    };
  },
  watch: {
    createTime(n, o) {
      this.form.CreateTimeStart = n ? n[0] : null;
      this.form.CreateTimeEnd = n ? n[1] : null;
    },
    settlementTime(n, o) {
      this.form.SettlementTimeStart = n ? n[0] : null;
      this.form.SettlementTimeEnd = n ? n[1] : null;
    },
  },
  created() {
    this.queryData();
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      this.buttonList_toolBar = buttonList.filter(item => item.buttonShow === 10);
      this.buttonList_table = buttonList.filter(item => item.buttonShow === 20);
    }
  },
  methods: {
    queryData() {
      this.loading = true
      SysSettlementOrderTotal(this.form).then(res => {
        if (res.data.result.success) {
          this.amount = res.data.result.data
        }
      })
      SysSettlementOrderList(this.form).then(res => {
        if (res.data.success) {
          this.tableData = res.data.result.data.data || []
          this.total = res.data.result.data.dataCount
        } else {
          this.$message.error(res.data.msg)
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    getData() {
      this.form.PageIndex = 1
      this.form.PageSize = 10
      this.queryData()
    },
    resetForm() {
      this.createTime = null
      this.settlementTime = null
      this.$refs["form"].resetFields();
      this.$nextTick(() => {
        this.getData()
      })
    },
    handleSizeChange(value) {
      this.form.PageSize = value
      this.queryData()
    },
    handleCurrentChange(value) {
      this.form.PageIndex = value
      this.queryData()
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    // callFunction(item) {
    //   this[item.Func](item);
    // },
    // callFunctionRow(item, index, row) {
    //   this[item.Func](item, index, row);
    // },
    handleExport() {
      ExportSysSettlementOrderList(this.form).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '已结算订单.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
      // ExportSysSettlementOrderList(this.form).then(res => {
      //   if (res.data.success) {
      //     this.$message.success("操作成功，请点击下载中心查看下载结果");
      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // })
    },
  },
};
</script>

<style scoped>
h2 span {
  color: red;
}
</style>
